import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDate as getDate } from '../../../hooks';
import './UpcomingConcertCard.scss';
import { tools } from '../../../utils';

const UpcomingConcertCard = ({ data }) => {
  const { title, poster, date, time, artists, about, to_be_confirmed } = data;
  const { day, month } = getDate(date);

  return (
    <Link to={`/calendar/${data.slug}`} className='upcoming__concert'>
      <div
        className='concert__logo'
        style={{ backgroundImage: `url('${poster}')` }}
      />

      <div className='concert__text'>
        <div className='dates'>
          {to_be_confirmed ? (
            <span>
              <p className='month'>TBC</p>
            </span>
          ) : (
            <>
              <span>
                <p className='day'>{day}</p>
                <p className='month'>{month}</p>
              </span>
              <div className='time'>
                START
                <p>{tools.timeConvert(time)}</p>
              </div>
            </>
          )}
        </div>

        <div className='head'>
          <span>
            <h2 className='title' dangerouslySetInnerHTML={{ __html: title }} />
            <h3 className='subtitle d-none' dangerouslySetInnerHTML={{ __html: data?.subtitle }} />
            <p
              className='about'
              dangerouslySetInnerHTML={{ __html: about?.substring(0, 200) }}
            />
          </span>

          <span>
            <div className='artists'>
              {artists.length &&
                artists.map(
                  (artist, i) =>
                    artist.role !== 'orchestra' && (
                      <div key={i} className='artist__avatar'>
                        <img
                          src={artist.avatar}
                          alt={`${artist.name} ${artist.surname}`}
                        />
                      </div>
                    )
                )}
            </div>

            <button className='concert__btn'>
              <img
                src='/media/icons/inclassica/right-arrow.svg'
                alt='arrow icon'
              />
            </button>
          </span>
        </div>
      </div>
    </Link>
  );
};

UpcomingConcertCard.propTypes = {
  data: PropTypes.object.isRequired,
};

export default UpcomingConcertCard;
